import React from 'react';
import t from 'rcm-i18n';

interface Props {
    order: any;
}

const orderContainsMobileAppItem = (order) => {
    return typeof order.conditions.find(
        (condition) => condition.name === 'order-contains-mobile-app-item'
    ) !== 'undefined';
};

const ReceiptMobileAppLink = ({ order }: Props) => {
    return <>
        {orderContainsMobileAppItem(order) &&
            <div className="panel panel-primary">
                <div className="panel-body">
                    <div>
                        {t('Your mobile app subscription has been activated.')}
                    </div>
                    <div>
                        <a href="http://mobile.rlvapp.com/getiphone.aspx">
                            <img style={{ height: '4em' }} src="https://reliv-static.s3-us-west-2.amazonaws.com/art/MobileApp/badges/smaller/appstorebadge-web.gif" />
                        </a>
                        <a href="http://mobile.rlvapp.com/getandroid.aspx">
                            <img style={{ height: '4em' }} src="https://reliv-static.s3-us-west-2.amazonaws.com/art/MobileApp/badges/smaller/appstorebuttongoogle-web.gif" />
                        </a>
                    </div>
                </div>
            </div>
        }
    </>;
};

export default ReceiptMobileAppLink;
